<template>
    <div v-if="$store.state.nextLaunch" class="next-launch">
        <div id="timer">
            <span class="days"></span>
            <span class="hours"></span>
            <span class="minutes"></span>
            <span class="seconds"></span>
        </div>
    </div><!-- /.next-launch -->
</template>

<script>
import jQuery from 'jquery'
export default {
    name: 'NextLaunch',
    props: ['nextLaunch'],
    data() {
        return {

        }
    },
    methods: {
        setTimer() {
            window.addEventListener('load', () => {
                window.$ = jQuery;
            });
            var remainingTime = this.nextLaunch.launch_date_unix;
            
            var MMode = setInterval(function() {
                MModeTimer(remainingTime)
            }, 1000);

            function MModeTimer(remainingTime) {
                
                
                var currentTime = new Date().getTime() / 1000;
                var futureTime = remainingTime;
                var timeRemaining = futureTime - currentTime;
                var minute = 60;
                var hour = 60 * 60;
                var day = 60 * 60 * 24;
                var dayFloor = Math.floor(timeRemaining / day);
                var hourFloor = Math.floor((timeRemaining - dayFloor * day) / hour);
                var minuteFloor = Math.floor((timeRemaining - dayFloor * day - hourFloor * hour) / minute);
                var secondFloor = Math.floor((timeRemaining - dayFloor * day - hourFloor * hour - minuteFloor * minute));
                var countdownCompleted = "Completed";

                if (secondFloor <= 0 && minuteFloor <= 0) {
                    window.location.reload(true);
                    clearInterval(MModeTimer);
                    document.getElementById("haha").innerHTML = countdownCompleted;

                } else {

                    if (futureTime > currentTime) {
                        
                        
                        
                        $('#timer .days').text(dayFloor + ' Days')
                        $('#timer .hours').text(hourFloor + ' Hours')
                        $('#timer .minutes').text(minuteFloor + ' Minutes')
                        $('#timer .seconds').text(secondFloor + ' Seconds')
                        // $('#haha').html(
                        // "<span>" + dayFloor + " Days </span>" +
                        // "<span>" + hourFloor + " Hours </span>" +
                        // "<span>" + minuteFloor + " Minutes </span>" +
                        // "<span>" + secondFloor + " Seconds </span>");
                    }
                }
            }
        }
    },
    mounted() {
        this.setTimer();
    }
}
</script>

<style>

</style>
